import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class FilePlus7 extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;


  seletedFoot: string = FilePlusFoot.Krom;

  defHideObjects = [
    '_yyy',
    '_xxx',
  ];

  defShowObjects =  [
    'file_plus_7_1_yyy',
    'file_plus_7_2_yyy',
    'xxx_file_plus_alt_yyy',
    'fileplus_7_yyy',
    'xxx_file_plus_kollar_yyy',
    'xxx_file_plus_kolcak_sag_yyy',
    'xxx_file_plus_kolcak_sol_yyy',
    'file_plus_ayak_krom_yyy',
    'xxx_file_plus_kolcak_dugme_yyy',
    'xxx_file_plus_donati_yyy',
    'xxx_file_plus_donati_yyy',
    'xxx_file_plus_kollar_krom_yyy',
    'kizaksiz',
    'donati',
    'xxx_file_plus_kolcak_dugme_sol_yyy',
    'xxx_file_plus_kolcak_dugme_sag_yyy',

  ];







  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('file_plus7');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes,['part'],['asc']);
    this.availableAnimations =  this.product.animations as any;
    this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });


    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });
      await this.changeFoot(Store.state.selection.footAndHand);
    }  else {
      await  this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new FilePlus7Selection();
    selection.parts = [];
    selection.footAndHand = FilePlusFoot.Krom;
    this.armAnimations(false);
    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;

  }



  async changeFoot(foot:FilePlusFoot) {
    if (foot === FilePlusFoot.Metal) {
      await this._configuratorService.hideObjects({ objects: ['file_plus_ayak_krom_yyy','file_plus_kollar_krom_yyy','xxx_file_plus_kollar_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['file_plus_ayak_aluminyum_yyy','file_plus_kolcak'], operator: FilterOperators.Contains });

      Store.state.selection.footAndHand = FilePlusFoot.Metal;
      this.seletedFoot = FilePlusFoot.Metal;
      this.armAnimations(true);
    }
    if (foot === FilePlusFoot.Krom) {
      await this._configuratorService.hideObjects({ objects: ['file_plus_ayak_aluminyum_yyy','file_plus_kolcak'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['file_plus_ayak_krom_yyy','file_plus_kollar_krom_yyy','xxx_file_plus_kollar_yyy'], operator: FilterOperators.Contains });


      Store.state.selection.footAndHand = FilePlusFoot.Krom;
      this.seletedFoot = FilePlusFoot.Krom;
      this.armAnimations(false);
    }
  }


  armAnimations(isArm: boolean) {

    let animations = [];
    if  (!isArm) {
      this.product.animations.forEach((element) => {
        if (!(element.animationName === 'a6'))  {
          animations.push(element);
        }
      });
    }  else {
      animations = this.product.animations as any[];

    }

    this.availableAnimations = animations;
    this.availableAnimationsChanged();

  }


  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const  getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}

export class FilePlus7Selection {
  parts: PartSelection[];
  footAndHand:FilePlusFoot;

}
export class PartSelection {
  id: string;
  palette: string;
  color: string;
  name:string;
}
enum FilePlusFoot {
  Metal = 'metal',
  Krom = 'krom',
}




// WEBPACK FOOTER //
// ./src/components/families/file-plus/FilePlus7.ts